import React, { forwardRef, useMemo } from "react";
import useStore from "./useStore";
import { CSSTransition, TransitionGroup } from "react-transition-group";
// import './index.scss';
import { createPortal } from "react-dom";
import { useTimer } from "./useTimer";
const MessageItem = (item) => {
    const { onMouseEnter, onMouseLeave } = useTimer({
        id: item.id,
        duration: item.duration,
        remove: item.onClose,
    });
    return React.createElement("div", { className: "message-item", onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, item.content);
};
export const MessageProvider = forwardRef((props, ref) => {
    const { messageList, add, update, remove, clearAll } = useStore('top');
    if ('current' in ref) {
        ref.current = {
            add,
            update,
            remove,
            clearAll
        };
    }
    // useImperativeHandle(ref, () => {
    //     return {
    //         add,
    //         update,
    //         remove,
    //         clearAll
    //     }
    // }, [])
    const positions = Object.keys(messageList);
    const messageWrapper = React.createElement("div", { className: "message-wrapper" }, positions.map(direction => {
        return React.createElement("div", { className: `message-wrapper-${direction}`, key: direction },
            React.createElement(TransitionGroup, null, messageList[direction].map(item => {
                return React.createElement(CSSTransition, { key: item.id, timeout: 1000, classNames: 'message' },
                    React.createElement(MessageItem, Object.assign({ onClose: remove }, item)));
            })));
    }));
    const el = useMemo(() => {
        const el = document.createElement('div');
        el.className = `wrapper`;
        document.body.appendChild(el);
        return el;
    }, []);
    return createPortal(messageWrapper, el);
});
